<div class="tw-flex tw-flex-col tw-gap-2 tw-py-4 tw-relative tw-min-h-40">
  @if(loading) {
    <div class="uw-container-overlay tw-flex tw-justify-center">
      <p-progressSpinner/>
    </div>
  }
  @if(orderFeedback) {
  <h5 class="tw-flex tw-items-center tw-justify-between">
    @if(submitted) { @if(!manage) { Thank you for your feedback! }
    <p-tag
      [rounded]="true"
      [severity]="feedback.Status == 'Approved' ? 'success' : 'warning'"
      >{{ feedback.Status }}</p-tag
    >
    } @else { Submit your feedback and earn points! }
  </h5>
  <h4>How would you rate your experience with this order?</h4>
  <brt-item-feedback-form
    [feedbackItem]="orderFeedback"
    [readOnly]="submitted"
    [canReply]="manage"
  />

  @if(orderFeedback?.Rating > 0) {
  <h4>How would you rate the order Items?</h4>
  <p-accordion [multiple]="true" [activeIndex]="[0]">
    @for(item of orderItems; track $index) {

    <p-accordionTab [header]="item.menuItem.Name">
      <brt-item-feedback-form
        [feedbackItem]="item.feedbackItem"
        [readOnly]="submitted"
        [canReply]="manage"
      />
    </p-accordionTab>
    }
  </p-accordion>

  @if(!submitted) {
  <p-button label="Submit Your Feedback" (click)="submitFeedback()"></p-button>
  } @if(manage) {
  <p-button label="Save" (click)="save()"></p-button>
  } } }
</div>
